const searchPartnerShops = (el) => {
    const val = el.value
    const targets = document.querySelectorAll('.link__liste a')
    targets.forEach(target => {
        const targetData = target.innerText.toLowerCase()
        const inputValue = val.toLowerCase()
        if (targetData.indexOf(inputValue) > -1) {
            target.style.display = ""
        } else {
            target.style.display = "none"
        }
    })
}


